/**
 * @generated SignedSource<<3ca6320dca6dd605af50e049d31435f7>>
 * @relayHash b9462568e06aecb4fb86e6e128d7b518
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9462568e06aecb4fb86e6e128d7b518

import { ConcreteRequest } from 'relay-runtime';
export type FeatureFlagType = "B2B_DATA_IMPORT_ENABLED" | "CHAT_AUTO_TRANSLATION" | "GENESYS_TELEPHONY" | "SPEECH_TO_TEXT";
export type useIsAutoTranslationEnabledQuery$variables = Record<PropertyKey, never>;
export type useIsAutoTranslationEnabledQuery$data = {
  readonly featureFlags: ReadonlyArray<{
    readonly featureFlag: FeatureFlagType;
    readonly isEnabled: boolean;
  }>;
};
export type useIsAutoTranslationEnabledQuery = {
  response: useIsAutoTranslationEnabledQuery$data;
  variables: useIsAutoTranslationEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "featureFlags",
    "value": [
      "CHAT_AUTO_TRANSLATION"
    ]
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useIsAutoTranslationEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "FeatureFlagResponse",
        "kind": "LinkedField",
        "name": "featureFlags",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": "featureFlags(featureFlags:[\"CHAT_AUTO_TRANSLATION\"])"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsAutoTranslationEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "FeatureFlagResponse",
        "kind": "LinkedField",
        "name": "featureFlags",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "featureFlags(featureFlags:[\"CHAT_AUTO_TRANSLATION\"])"
      }
    ]
  },
  "params": {
    "id": "b9462568e06aecb4fb86e6e128d7b518",
    "metadata": {},
    "name": "useIsAutoTranslationEnabledQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "081d3cc874575f0860b3e3b5fa6ec084";

export default node;
